import { Pipe, PipeTransform } from '@angular/core';
import { LacertaMapper } from './mapper.model';

@Pipe({ name: 'lacertaMapper' })
export class LacertaMapperPipe<T, G> implements PipeTransform {
  transform(value: T, mapper: LacertaMapper<T, G>, ...args: unknown[]): G {
    return mapper(value, ...args);
  }
}
